<template>
  <header id="lm-header">
    <div class="navbar-custom d-flex justify-content-between align-items-center">
      <transition name="fade" appear v-if="!lumbredocs_v3">
        <div class="app-search d-none d-xl-block">
          <div class="input-group d-none">
            <input type="text" class="form-control app-search__main-input" :placeholder="$t('Search')">
            <span class="mdi mdi-magnify"></span>
            <div class="input-group-append">
              <button class="btn btn-primary" type="submit">{{ $t('Search')}}</button>
            </div>
          </div>
        </div>
      </transition>
      <section class="d-flex align-items-center" v-if="lumbredocs_v3">
        <button
          class="menu-toggle-button mr-3"
          @click="$emit('toggleMenu')"
        >
          <i class="mdi mdi-menu"></i>
        </button>
        <router-link to="/" class="d-block">
          <img :src="$store.state.settings.logoImg" alt="Logo" class="logo-img">
        </router-link>
      </section>

      <div class="d-flex">
        <!-- Notifications -->
        <b-dropdown
          no-caret
          variant="link"
          toggle-class="text-decoration-none notifications-toggle"
          right text="Right align"
          menu-class="notifications-card notifications-box shadow bg-white py-0"
          @toggle="onToggleNotifications"
          ref="notifications"
        >
          <template #button-content>
            <i
              class="mdi mdi-bell-outline"
              :class="{'text-primary': showingNotifications, 'text-secondary': !showingNotifications, 'animate-bell-icon': unreadNotifications}"
              style="font-size: 1.8rem"
            ></i>
            <span class="noti-icon-badge" v-if="unreadNotifications"></span>
          </template>

          <b-card
            no-body
            footer-bg-variant="white"
            footer-class="border-top"
            header-bg-variant="primary"
            header-class="py-1"
            class="m-0"
          >
            <template #header class="bg-white">
              <h5 class="text-left text-white">{{ $t('notifications') }}</h5>
            </template>

            <div v-if="!notifications.length">
              <LmSvgIcon
                icon="LmNoNotifyIcon"
                wrapperClass="my-4 d-flex align-items-center flex-column"
                text="No tienes notificaciones"
              />
            </div>

            <b-list-group flush class="scroll" v-else>
              <b-list-group-item
                v-for="(notification, index) in notifications"
                :key="index"
                :to="notification.click_action"
                :title="notification.title"
              >
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{notification.title}}</h5>
                <small>{{notificationDate(notification)}}</small>
              </div>
              <p class="mb-1 notification-body">
                {{notification.body}}
              </p>
              </b-list-group-item>
            </b-list-group>

            <template #footer>
              <h5 class="text-center">
                <router-link :to="allNotificationsRoute">{{ $t('show_more') }}</router-link>
              </h5>
            </template>
          </b-card>
        </b-dropdown>

        <!-- Profile -->
        <b-dropdown
          id="ddown-header"
          variant="transparent"
          no-caret
          class="m-0 p-0"
          menu-class="shadow"
        >
          <template slot="button-content">
            <div class="account-user-avatar">
              <LmProfilePicture :size="'2rem'"/>
            </div>
            <div class="wrapperUserInfo d-none d-xl-block">
              <span class="account-user-name">{{ accountUserName }}</span>
              <div v-for="(r, index) in roles" :key="index">
                <span class="account-position">{{ r }}</span>
              </div>
              <span class="account-position">{{ role }}</span>
            </div>
          </template>
          <b-dropdown-header>
            <h6>{{ $t('hello') }}</h6>
          </b-dropdown-header>
          <template v-if="extra.customers && extra.customers.length > 1">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-for="item in extra.customers"
              :key="item.id"
              :active="item.id === extra.customerId"
              @click="onChangeCustomer(item.id)"
            >
              {{ item.name }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </template>
          <b-dropdown-item :to="userProfileRoute">
            <i class="mdi mdi-account-circle"></i>
            <span>{{ $t('my_profile') }}</span>
          </b-dropdown-item>
          <b-dropdown-item :to="el.path" v-for="(el, index) in dropdownMenuItems.data.dropdownMenuItems" :key="index">
            <i class="mdi" :class="el.icon"></i>
            <span>{{el.name}}</span>
          </b-dropdown-item>
          <b-dropdown-item @click="logout()">
            <i class="mdi mdi-logout"></i>
            <span>{{ $t('Logout') }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </div>
  </header>
</template>

<script>
import LmProfilePicture from '@/components/LmProfilePicture.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  inject: ['lumbredocs_v3'],
  data () {
    return {
      user: {},
      isShowedViewMore: true,
      showingNotifications: false,
      dropdownMenuItems: {
        data: {
          dropdownMenuItems: {}
        }
      },
      menuExpanded: true
    }
  },
  components: {
    LmProfilePicture
  },
  props: {
    activeShowMoreAt: {
      type: Number,
      default: 10
    }
  },
  computed: {
    allNotificationsRoute () {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
        return `/${process.env.VUE_APP_LUMBRE_MICROSERVICES_NOTIFICATIONS_PATH}`
      } else {
        return `/${process.env.VUE_APP_LUMBRE_NOTIFICATIONS_PATH}`
      }
    },
    userProfileRoute () {
      if (process?.env?.VUE_APP_LUMBRE_PROFILEV2_ENABLED === 'yes') {
        return `/profile`
      } else {
        return `/user-profile`
      }
    },
    userInitials () {
      if (this.user.firstname && this.user.lastname) {
        return this.user.firstname.charAt(0) + this.user.lastname.charAt(0)
      } else {
        return ''
      }
    },
    ...mapState('session', ['profilePicture', 'role', 'roles', 'extra']),
    ...mapGetters('session', ['accountUserName']),
    ...mapState('notifications', ['notifications', 'unreadNotifications'])
  },
  methods: {
    onToggleNotifications () {
      this.showingNotifications = !this.showingNotifications
      if (this.showingNotifications) {
        this.clearUnreadNotifications()
      }
    },
    notificationDate (notification) {
      if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
        return notification.timeAgoDate
      } else {
        return notification.date
      }
    },
    hideDropDown () {
      this.$refs.notifications.hide(true)
    },
    clearUnreadNotifications () {
      this.actionClearUnreadNotifications()
    },
    async logout () {
      try {
        await this.$store.dispatch('session/logout')
        location.href = '/login'
      } catch (error) {
        console.log('error logout header', error)
      }
    },
    async onChangeCustomer (id) {
      // TODO. Cambio el cliente del usuario logueado
      try {
        await commonsApi.axiosPutWrapper('/users/change-customer', { id })
        this.mutateCustomerId(id)
        this.$router.go()
      } catch (error) {
        console.log(error)
      }
    },
    ...mapMutations('menu', ['mutationIsOpen']),
    ...mapMutations('notifications', ['mutateUpdateTimeAgo']),
    ...mapMutations('session', ['mutateCustomerId']),
    ...mapActions('notifications', ['actionClearUnreadNotifications']),
    ...mapActions('commons', ['getItems'])
  },
  async created () {
    if (process?.env?.VUE_APP_LUMBRE_PROFILEV2_ENABLED === 'yes') {
      const getUser = await commonsApi.axiosGetWrapper(`/profile/userinfo`)
      this.user = getUser.data
    } else {
      const userInfoURL = process.env.VUE_APP_SESSION_GET_USERINFO_URL ? process.env.VUE_APP_SESSION_GET_USERINFO_URL : '/users/info'
      const getUser = await commonsApi.axiosGetWrapper(userInfoURL)
      this.user = getUser.data
    }
  },
  async mounted () {
    if (process?.env?.VUE_APP_ENABLE_MICROSERVICES_NOTIFICATIONS === 'yes') {
      let updatingTimeAgo
      this.$refs.notifications.$on('show', () => {
        this.mutateUpdateTimeAgo()
        this.showingNotifications = true
        updatingTimeAgo = setInterval(() => {
          this.mutateUpdateTimeAgo()
        }, 1000 * 60)
      })
      this.$refs.notifications.$on('hidden', () => {
        clearInterval(updatingTimeAgo)
        this.showingNotifications = false
      })
    }
    if (process.env.VUE_APP_DROPDOWN_MIDDLE_MENU === 'yes') {
      this.dropdownMenuItems = await commonsApi.getItems({
        path: `${process.env.VUE_APP_API_SETTINGS_URI}/dropdownmenu/`
      })
    }
  },
  watch: {
    '$route' () {
      this.hideDropDown()
    }
  }
}
</script>

<style lang="sass">
  #lm-header
    @keyframes shake
      10%
        transform: rotate(15deg)
      20%
        transform: rotate(-15deg)
      30%
        transform: rotate(15deg)
      50%
        transform: rotate(0deg)

    .logo-img
      width: 100%
      height: auto
      max-width: 200px
      max-height: 50px
    .menu-toggle-button
      background: transparent
      border: none
      font-size: 1.5rem

    .mdi-bell-outline.animate-bell-icon:before
      animation: shake 1.5s forwards infinite
    .scroll
      overflow-y: auto
      &::-webkit-scrollbar-track
        background: #f1f1f1
      &::-webkit-scrollbar
        width: 8px
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
      &::-webkit-scrollbar-thumb:hover
        background: #555
    .notification-body
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
    .notifications-box
      width: 350px
      max-height: 500px
      .card
        max-height: 500px
    .notifications-toggle
      &:focus
        outline: none !important
        box-shadow: none !important
    .notifications-card
      width: 360px
      top: -15px !important
    .navbar-custom
      padding: 0 30px
      background-color: #fff
      box-shadow: 0 0 35px 0 rgba(154,161,171,.15)
      min-height: 70px
      @media(max-width: $xl)
        padding: 0 10px
      .button-menu-mobile
        border: none
        color: #313a46
        height: 70px
        line-height: 70px
        width: 60px
        background-color: transparent
        font-size: 24px
        cursor: pointer
        float: left
        &:focus
          outline: none
      #notification-header
        float: right
        position: static
        @media(min-width: $xl)
          position: relative
        .media-body
          max-width: 85%
        .notification-header-body
          font-size: 14px
        .notification-header-date
          font-size: 11px
        .notify-all
          font-size: 14px
          color: $primaryThemeColor
          padding: 10px 20px
          &:hover
            text-decoration: none
            background-color: #f8f9fa
            color: #4250f2
        .noti-icon-badge
          display: inline-block
          position: absolute
          top: 20px
          right: 15px
          border-radius: 50%
          height: 10px
          width: 10px
          background-color: #fa5c7c
        .noti-icon
          font-size: 22px
          vertical-align: middle
          line-height: 70px
        .dropdown-menu
          width: 100%
          @media(min-width: $md)
            width: 320px
        .noti-title
          background-color: #fff
          padding: 15px 20px
          h5
            font-size: 15px
          small
            font-size: 12px
        .wrapper-dropdown-item
          max-height: 230px
          overflow: auto
          .notify-item
            padding: 10px 20px
            &:hover
              background: red
            .notify-icon
              float: left
              height: 36px
              width: 36px
              line-height: 36px
              text-align: center
              margin-right: 10px
              border-radius: 50%
              color: #fff
              i
                margin: 0
            .notify-details
              margin-bottom: 0
              overflow: hidden
              margin-left: 45px
              text-overflow: ellipsis
              white-space: nowrap
              font-size: 14px
              b
                font-weight: 500
              small
                display: block
                font-size: 12px
      #ddown-header
        color: $mutedFontThemeColor
        min-width: 32px
        display: block
        margin: 0 8px
        text-align: left !important
        position: relative
        background-color: #fafbfd
        border: 1px solid #f1f3fa
        border-width: 0 1px
        min-height: 70px
        float: right
        padding: 5px 20px
        .account-user-avatar
          float: left
          img
            width: 32px
            height: 32px
            max-width: 100%
            max-height: 100%
        .wrapperUserInfo
          text-align: left
          padding-left: 10px
          float: left
          .account-user-name
            font-weight: 600
            color: $mutedFontThemeColor
            font-size: 14px
            display: block
            white-space: initial
          .account-position
            display: block
            font-size: 12px
            margin-top: -3px
            color: $mutedFontThemeColor
            white-space: initial
      .dropdown-menu
        z-index: $zIndexLmDropdownMenu
        .dropdown-item
          padding: 7px 20px
          display: block
          width: 100%
          clear: both
          font-weight: 400
          text-align: inherit
          white-space: nowrap
          background-color: transparent
          border: 0
          &.active
            background-color: #007bff
            &:hover
              background-color: #007bff
          &:hover
            background-color: #f8f9fa
          i
            vertical-align: middle
            margin-right: 5px
            font-size: 14px
          span
            font-size: 14px
            vertical-align: middle
      .dropdown-header
        display: block
        padding: .25rem 1.5rem
        margin-bottom: 0
        font-size: .875rem
        color: inherit
        white-space: nowrap
        &.noti-title
          padding: 15px 20px
          h6
            font-size: 12px
      .app-search
        padding: 16px 0
        overflow: hidden
        float: left
        button
          font-size: 14px
        form
          max-width: 320px
          .input-group
            position: relative
            display: flex
            flex-wrap: wrap
            align-items: stretch
            width: 100%
        .app-search__main-input
          border: none
          height: 38px
          padding-left: 40px
          padding-right: 20px
          background-color: #f1f3fa
          box-shadow: none
          &::-webkit-input-placeholder
            color: #c1c1c1
            font-size: 14px
        .mdi-magnify
          position: absolute
          z-index: 9
          font-size: 20px
          line-height: 38px
          left: 10px
        .input-group-append
          margin-left: 0
          z-index: 4
</style>
